export const URL_TERMS = 'https://anyword.com/anyword-terms-of-service/';
export const URL_PRIVACY_POLICY = 'https://anyword.com/privacy-policy';
export const URL_VISIT_APPSUMO = 'https://appsumo.com/account/products';
export const URL_G2_REVIEW = 'https://www.g2.com/products/anyword/reviews/start';

export const SUPPORT_URL = 'https://www.anyword.com/contact-us';

export const URL_HELP_CENTER = 'https://support.anyword.com';
export const URL_HELP_CENTER_BRAND_VOCABULARY =
  'https://support.anyword.com/how-to-import-brand-vocabulary-guidelines';
export const URL_HELP_CENTER_WEBSITE_AUTOMATION =
  'https://support.anyword.com/how-to-setup-anyword-website-automation';

export const DEBOUNCED_CALL_STATUS = {
  started: 'started',
  success: 'success',
  error: 'error',
};

export const WISTIA_VIDEO_ID = {
  toneOfVoice: '1qarcexcp8',
  targetAudiences: 'l9xovpdw0i',
  extensionOnboarding: 'p3lqnx4c4y',
  homeOnboardingIntegrations: 'f7aq3xxcrz',
  homeOnboardingTargetAudience: 'utfr8tquek',
  homeOnboardingToneOfVoice: '00hhj8whxz',
};

export const GENERATION_PANEL_MENU_TYPE = {
  toneOfVoice: 'toneOfVoice',
  talkingPoints: 'talkingPoints',
  structure: 'structure',
  imageStyles: 'imageStyles',
  imageOverlay: 'imageOverlay',
  advanced: 'advanced',
};
